const TRIAL_PROGRAM_IDS = [24, 29];

export const isTrialUser = userClaims =>
  TRIAL_PROGRAM_IDS.includes(userClaims?.program_id);
